import {
  IVitalListEmptyEntry,
  TBloodPressure,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import { getDateFormat } from '../../utils-helpers';
import moment from 'moment';
import getGraphData from '../get-graph-data';
import getBadgeProps from '../get-badge-props';

/**
 * blood-pressure
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
function getBloodPressureEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
) {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/icon-blood-pressure.svg').default,
    title: 'life_id.bloodPressure',
  };

  if (
    !vitalDataSettings ||
    !vitalData ||
    !vitalData.bloodPressureSystolic ||
    !vitalData.bloodPressureDiastolic
  ) {
    return emptyEntry;
  }

  const settings = [
    vitalDataSettings.bloodPressureSystolic,
    vitalDataSettings.bloodPressureDiastolic,
  ];

  return {
    ...emptyEntry,
    modalType: 'SYSTOLIC' as const,
    isEmpty: false,
    average: `${vitalData.bloodPressureSystolic.average || '-'} / ${
      vitalData.bloodPressureDiastolic.average || '-'
    }`,
    status: [
      `life_id:status.${vitalData.bloodPressureSystolic.lastRecord.status}`,
      `life_id:status.${vitalData.bloodPressureDiastolic.lastRecord.status}`,
    ],
    ...getBadgeProps(vitalData.bloodPressureDiastolic.lastRecord.source),
    getDetailRowProps: (itemFromSearchApi: TBloodPressure) => {
      const systolicVal = itemFromSearchApi[
        config.BLOOD_PRESSURE.valueSelectors[0] as keyof TVitalDataSearchItem
      ] as string;
      const diastolicVal = itemFromSearchApi[
        config.BLOOD_PRESSURE.valueSelectors[1] as keyof TVitalDataSearchItem
      ] as string;

      return {
        time: moment(itemFromSearchApi.datetime).format(getDateFormat()),
        createdTime: moment(itemFromSearchApi.datetime).format('HH:mm'),
        value: `${systolicVal}/${diastolicVal}`,
        chartProps: {
          ...getGraphData(settings, [systolicVal, diastolicVal], undefined, 'line'),
        },
        ...getBadgeProps(itemFromSearchApi.source),
      };
    },
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.BLOOD_PRESSURE.unit[0]}`,
      value: `${vitalData.bloodPressureSystolic.lastRecord.systolic}/${vitalData.bloodPressureDiastolic.lastRecord.diastolic}`,
      ...getGraphData(settings, [
        vitalData.bloodPressureSystolic.lastRecord.systolic,
        vitalData.bloodPressureDiastolic.lastRecord.diastolic,
      ]),
    },
    urlPart: config.BLOOD_PRESSURE.urlPart,
  };
}

export default getBloodPressureEntry;
